import elementExists from "../utils/elementExists"

const Header = function () {
    const navOpen = document.querySelector('#navOpen');
    const navClose = document.querySelector('#navClose');
    const takeover = document.querySelector('#top-nav');

    navOpen.addEventListener('click', function () {
        document.body.setAttribute('data-nav-open', '');
        takeover.classList.remove('collapse');
    });

    navClose.addEventListener('click', function () {
        document.body.removeAttribute('data-nav-open');
        takeover.classList.add('collapse');
        resetNav();
    });

    // Search Bar
    const navIcon = document.querySelector('#nav-search');
    const searchbar = document.querySelector('#search-desktop');
    const searchOverlay = document.querySelector('.search-overlay');    

    if (elementExists(searchOverlay)) {
        function removeSearchBar() {
            searchbar.classList.remove('show');
            navIcon.classList.remove('show');
        }
        function toggleSearchBar() {
            searchbar.classList.toggle('show');
            navIcon.classList.toggle('show');
        }
        document.addEventListener("keydown", ({key}) => {
            if (key === "Escape") {
                if ( searchbar.classList.contains('show') ) {
                    removeSearchBar();
                }
            }
        });
        navIcon.addEventListener('click', function () { toggleSearchBar(); });
        searchOverlay.addEventListener('click', function () { removeSearchBar(); });
    }


    // Subnav
    let navItem = document.querySelectorAll('.nav-link');
    let subItem = document.querySelectorAll('.subnav');
    let menuheader = document.querySelector('.menu-header');
    let backButton = document.querySelector('.menu-back');

    function resetNav() {
        menuheader.classList.remove('hide');
        backButton.classList.remove('show');
        subItem.forEach(sub => {
            sub.classList.remove('show');
            sub.setAttribute('aria-hidden', 'true');
        });
    }

    navItem.forEach(nav => {
        nav.addEventListener('click', function () {
            menuheader.classList.add('hide');
            backButton.classList.add('show');
            subItem.forEach(sub => {
                let thisSub = sub.getAttribute('data-subnav');
                if ( nav.getAttribute('data-subnav') == thisSub ) {
                    sub.classList.add('show');
                    sub.setAttribute('aria-hidden', 'false');
                }
            });
        });
    });

    backButton.addEventListener('click', function () {
        resetNav();
    });


    // // Detect Scrolling
    let navbar = document.querySelector('.navbar');
    const mainHeader = document.querySelector('#main-header-wrap');
    let scrollableElement = document.body;
    scrollableElement.addEventListener('wheel', checkScrollDirection);
    scrollableElement.addEventListener('touchmove', checkScrollDir);
    if ( window.pageYOffset < 50) {
        navbar.classList.remove('show');
    } else {
        navbar.classList.add('show');
    }



    // // Mobile
    let scrollY = window.pageYOffset;
    window.addEventListener('touchstart', (event) => {
        passive: true,
        scrollY = window.pageYOffset;
        return scrollY;
    });

    function checkScrollDir () {
        window.addEventListener('touchmove', (event) => { 
            if ( window.pageYOffset < 50) {
                navbar.classList.remove('show');
            } else {
                navbar.classList.add('show');
            }
            passive: true
        });
    }

    
    // Desktop
    function checkScrollDirection(event) {
        if (checkScrollDirectionIsUp(event) && window.scrollY < 50 ) {
            navbar.classList.remove('show');
        } 
        else {
            navbar.classList.add('show');
        }
    }
    
    function checkScrollDirectionIsUp(event) {
        if (event.wheelDelta) {
            return event.wheelDelta > 0;
        }
        return event.deltaY < 0;
    }
}

export default Header;
